import _ from 'lodash';
import {
    FETCH_AI_COMMAND_ITEMS,
    CLEAN_AI_COMMAND_ITEMS,
    RUN_AI_COMMAND_ITEM,
    RUN_AI_COMMAND_ITEMS,
    DELETE_AI_COMMAND_ITEM,
    DELETE_AI_COMMAND_ITEMS,
    EDIT_AI_COMMAND_ITEM,
    EDIT_AI_COMMAND_ITEMS,
    SAVE_AI_COMMAND_ITEMS,
} from './types';
import { request, __ } from '../functions';

export const fetchAiCommandItems = (screen, ai_command_id, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-command-items/index/${ai_command_id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_COMMAND_ITEMS, payload: data });
    });
};

export const runAiCommandItem = (screen, id) => {
    return dispatch => request(`/ai-command-items/setWaiting/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa spustiť položku'));
            return;
        }

        screen.showSnackbar('success', __('Položka bola spustená'));

        dispatch({ type: RUN_AI_COMMAND_ITEM, payload: [id] });
    });
};

export const deleteAiCommandItem = (screen, id) => {
    return dispatch => request(`/ai-command-items/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať položku'));
            return;
        }

        screen.showSnackbar('success', __('Položka bola zmazaná'));

        dispatch({ type: DELETE_AI_COMMAND_ITEM });
    });
};

export const editAiCommandItem = (screen, id, input, output) => {
    return dispatch => request(`/ai-command-items/edit/${id}`, { input, output }, 'POST').then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa upraviť položku'));
            return;
        }

        screen.showSnackbar('success', __('Položka bola upravená'));

        dispatch({ type: EDIT_AI_COMMAND_ITEM, payload: { id, modified: data.modified } });
    });
};

export const deleteAiCommandItems = (screen, ai_command_id, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-command-items/multiDelete/${ai_command_id}/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať položky'));
            return;
        }

        screen.showSnackbar('success', __('Položky boli zmazané'));

        dispatch({ type: DELETE_AI_COMMAND_ITEMS });
    });
};

export const runAiCommandItems = (screen, ai_command_id, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-command-items/multiWaiting/${ai_command_id}/${ids}`, params).then(response => {
        const { data, status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa spustiť položky'));
            return;
        }

        screen.showSnackbar('success', __('Položky boli spustené'));

        dispatch({ type: RUN_AI_COMMAND_ITEMS, payload: data.ids });
    });
};

export const editAiCommandItems = (screen, ai_command_id, ids, input, output, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-command-items/multiEdit/${ai_command_id}/${ids}`, { input, output }, 'POST', params).then(response => {
        const { data, status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa upraviť položky'));
            return;
        }

        screen.showSnackbar('success', __('Položky boli upravené'));

        dispatch({ type: EDIT_AI_COMMAND_ITEMS, payload: data.modified });
    });
};

export const saveAiCommandItems = (screen, ai_command_id, save_field, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-command-items/multiSave/${ai_command_id}/${save_field}/${ids}`, params).then(response => {
        const { data, status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa uložiť položky'));
            return;
        }

        if (_.has(data, 'is_processing') && data.is_processing) {
            // Refresh
            window.location = `/ai-commands/view/${ai_command_id}`;
            return;
        }

        if (!_.isEmpty(data.errors)) {
            if (!_.isEmpty(data.success)) {
                screen.showSnackbar('warning', __('Uložených položiek: {SUCCESS}, Neuložených: {ERROR}')
                    .replace('{SUCCESS}', _.keys(data.success).length.toString())
                    .replace('{ERROR}', _.keys(data.error).length.toString())
                );
            } else {
                screen.showSnackbar('error', __('Nepodarilo sa uložiť položky'));
            }
        } else {
            screen.showSnackbar('success', __('Položky boli uložené'));
        }

        dispatch({ type: SAVE_AI_COMMAND_ITEMS, payload: data });
    });
};

export const cleanAiCommandItems = () => ({ type: CLEAN_AI_COMMAND_ITEMS });
